export const GET_ALL_PRODUCT_REQUEST = "PRODUCT.GET_ALL_PRODUCT_REQUEST";
export const GET_ALL_PRODUCT_SUCCESS = "PRODUCT.GET_ALL_PRODUCT_SUCCESS";
export const GET_ALL_PRODUCT_FAILURE = "PRODUCT.GET_ALL_PRODUCT_FAILURE";

export const CLEAR_SEARCHTERM = "PRODUCT.CLEAR_SEARCHTERM";

export const GET_SINGLE_PRODUCT_REQUEST = "PRODUCT.GET_SINGLE_PRODUCT_REQUEST";
export const GET_SINGLE_PRODUCT_SUCCESS = "PRODUCT.GET_SINGLE_PRODUCT_SUCCESS";
export const GET_SINGLE_PRODUCT_FAILURE = "PRODUCT.GET_SINGLE_PRODUCT_FAILURE";

export const ADD_PRODUCT_REQUEST = "PRODUCT.ADD_PRODUCT_REQUEST";
export const ADD_PRODUCT_SUCCESS = "PRODUCT.ADD_PRODUCT_SUCCESS";
export const ADD_PRODUCT_FAILURE = "PRODUCT.ADD_PRODUCT_FAILURE";

export const UPDATE_PRODUCT_REQUEST = "PRODUCT.UPDATE_PRODUCT_REQUEST";
export const UPDATE_PRODUCT_SUCCESS = "PRODUCT.UPDATE_PRODUCT_SUCCESS";
export const UPDATE_PRODUCT_FAILURE = "PRODUCT.UPDATE_PRODUCT_FAILURE";

export const DELETE_PRODUCT_REQUEST = "PRODUCT.DELETE_PRODUCT_REQUEST";
export const DELETE_PRODUCT_SUCCESS = "PRODUCT.DELETE_PRODUCT_SUCCESS";
export const DELETE_PRODUCT_FAILURE = "PRODUCT.DELETE_PRODUCT_FAILURE";
